/* SK Blog Grid - filtrado por categoria, busqueda y paginacion client-side */
(function() {
  'use strict';

  function initSection(container) {
    /* R45: guard contra doble inicializacion */
    if (container.dataset.skInit) return;
    container.dataset.skInit = 'true';

    /* R46: buscar dentro del container */
    var searchInput = container.querySelector('[data-search-input]');
    var grid = container.querySelector('[data-grid]');
    var filterToggle = container.querySelector('[data-filter-toggle]');
    var filtersMobile = container.querySelector('[data-filters-mobile]');
    var pagination = container.querySelector('[data-pagination]');
    var perPage = parseInt(container.getAttribute('data-per-page'), 10) || 8;

    var allCards = grid ? Array.prototype.slice.call(grid.querySelectorAll('.sk-blog-grid__card')) : [];
    var currentFilter = 'all';
    var currentPage = 1;

    /* Ordenar por fecha mas reciente primero */
    allCards.sort(function(a, b) {
      return (parseInt(b.getAttribute('data-date'), 10) || 0) - (parseInt(a.getAttribute('data-date'), 10) || 0);
    });

    /* Reordenar en el DOM */
    for (var c = 0; c < allCards.length; c++) {
      grid.appendChild(allCards[c]);
    }

    /* Obtener cards que cumplen filtro + busqueda */
    function getVisibleCards() {
      var query = searchInput ? searchInput.value.toLowerCase().trim() : '';
      return allCards.filter(function(card) {
        var matchCategory = currentFilter === 'all' || card.getAttribute('data-category') === currentFilter;
        var matchSearch = query === '' || (card.getAttribute('data-article-title') || '').toLowerCase().indexOf(query) !== -1;
        return matchCategory && matchSearch;
      });
    }

    /* Mostrar/ocultar cards y actualizar paginacion */
    function render() {
      var visible = getVisibleCards();
      var totalPages = Math.ceil(visible.length / perPage);
      if (currentPage > totalPages) currentPage = Math.max(1, totalPages);

      var start = (currentPage - 1) * perPage;
      var end = start + perPage;

      /* Ocultar todas */
      for (var i = 0; i < allCards.length; i++) {
        allCards[i].classList.add('sk-blog-grid__card--hidden');
      }

      /* Mostrar solo las de la pagina actual */
      for (var j = 0; j < visible.length; j++) {
        if (j >= start && j < end) {
          visible[j].classList.remove('sk-blog-grid__card--hidden');
        }
      }

      renderPagination(totalPages);
    }

    /* Generar botones de paginacion */
    function renderPagination(totalPages) {
      if (!pagination) return;
      if (totalPages <= 1) {
        pagination.innerHTML = '';
        return;
      }

      var html = '';

      /* Boton anterior */
      if (currentPage > 1) {
        html += '<button type="button" class="sk-blog-grid__page-btn" data-page="' + (currentPage - 1) + '" aria-label="Pagina anterior">&lsaquo;</button>';
      }

      /* Numeros de pagina con ellipsis */
      for (var p = 1; p <= totalPages; p++) {
        if (p === currentPage) {
          html += '<span class="sk-blog-grid__page-btn sk-blog-grid__page-btn--active" aria-current="page">' + p + '</span>';
        } else if (p === 1 || p === totalPages || Math.abs(p - currentPage) <= 1) {
          html += '<button type="button" class="sk-blog-grid__page-btn" data-page="' + p + '">' + p + '</button>';
        } else if (Math.abs(p - currentPage) === 2) {
          html += '<span class="sk-blog-grid__page-btn sk-blog-grid__page-btn--ellipsis">...</span>';
        }
      }

      /* Boton siguiente */
      if (currentPage < totalPages) {
        html += '<button type="button" class="sk-blog-grid__page-btn" data-page="' + (currentPage + 1) + '" aria-label="Pagina siguiente">&rsaquo;</button>';
      }

      pagination.innerHTML = html;
    }

    /* Cambio de pagina con animacion fade */
    function goToPage(page) {
      if (page === currentPage) return;
      currentPage = page;

      grid.classList.add('sk-blog-grid__grid--fading');
      container.scrollIntoView({ behavior: 'smooth', block: 'start' });

      setTimeout(function() {
        render();
        requestAnimationFrame(function() {
          grid.classList.remove('sk-blog-grid__grid--fading');
        });
      }, 300);
    }

    /* Cambio de filtro con animacion */
    function setFilter(filter) {
      if (filter === currentFilter) return;
      currentFilter = filter;
      currentPage = 1;

      /* Actualizar pills activas (desktop + mobile) */
      var allFilters = container.querySelectorAll('.sk-blog-grid__filter');
      for (var i = 0; i < allFilters.length; i++) {
        if (allFilters[i].getAttribute('data-filter') === filter) {
          allFilters[i].classList.add('sk-blog-grid__filter--active');
        } else {
          allFilters[i].classList.remove('sk-blog-grid__filter--active');
        }
      }

      grid.classList.add('sk-blog-grid__grid--fading');

      setTimeout(function() {
        render();
        requestAnimationFrame(function() {
          grid.classList.remove('sk-blog-grid__grid--fading');
        });
      }, 300);
    }

    /* Delegacion de eventos: filtros y paginacion */
    container.addEventListener('click', function(e) {
      /* Click en filtro */
      var filterBtn = e.target.closest('.sk-blog-grid__filter');
      if (filterBtn && filterBtn.getAttribute('data-filter')) {
        setFilter(filterBtn.getAttribute('data-filter'));
        return;
      }

      /* Click en boton de paginacion */
      var pageBtn = e.target.closest('.sk-blog-grid__page-btn[data-page]');
      if (pageBtn) {
        goToPage(parseInt(pageBtn.getAttribute('data-page'), 10));
        return;
      }
    });

    /* Buscador: filtrar al escribir */
    if (searchInput) {
      searchInput.addEventListener('input', function() {
        currentPage = 1;
        render();
      });
    }

    /* Toggle filtros mobile */
    if (filterToggle && filtersMobile) {
      filterToggle.addEventListener('click', function() {
        var isOpen = filtersMobile.classList.toggle('sk-blog-grid__filters-mobile--open');
        filterToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    /* Render inicial */
    render();
  }

  /* R44: querySelectorAll para TODAS las instancias */
  var sections = document.querySelectorAll('.sk-blog-grid');
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  /* R48: re-iniciar en el Customizer */
  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target.querySelector('.sk-blog-grid');
    if (section) initSection(section);
  });
})();
